import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { CompleteRedirectLoginAction } from '®shared/current-user/current-user.actions';

@Component({
  selector: 'rl-redirect-authentication',
  template: '<ng-container><rl-loader></rl-loader></ng-container>',
})
export class RedirectAuthenticationComponent implements OnInit {
  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(new CompleteRedirectLoginAction());
  }
}
